import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Chip } from '@material-ui/core';
import RepartoChip from './RepartoChip';
import { isRepartoPresente } from './visibilitaAllegati';

export const INTERA_STRUTTURA_LABEL = 'Intera struttura';

const useStyles = makeStyles((theme) => ({
  pills: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
  // Quiet on purpose: this is the default and the state of everything that
  // predates restrictions, so it must not compete with the rows that carry one.
  intera: {
    color: theme.palette.text.secondary,
  },
}));

/**
 * Who sees a row of the list. The row's own restriction when it has one; else
 * `ereditata`, the restriction the open folder passes down to what is inside
 * it, drawn as inherited — reading inherits the same way on the server, so a
 * row without a restriction of its own inside a restricted folder is seen by
 * the folder's reparti, not by the whole structure. Only with neither is the
 * row visible to the whole structure. `ereditata` is `null` where the caller
 * cannot say, as in search results, which come from anywhere.
 *
 * `repartiEsistenti` is what the esercizio currently has, or `null` while that
 * is unknown: a reparto can be called missing only against a list that was
 * actually read.
 */
export default function VisibilitaPills({
  repartiVisibilita,
  ereditata,
  repartiEsistenti,
}) {
  const classes = useStyles();
  const proprie = Array.isArray(repartiVisibilita) ? repartiVisibilita : [];
  const dallaCartella = Array.isArray(ereditata) ? ereditata : [];
  const reparti = proprie.length > 0 ? proprie : dallaCartella;

  if (reparti.length === 0) {
    return (
      <Chip
        size="small"
        variant="outlined"
        label={INTERA_STRUTTURA_LABEL}
        className={classes.intera}
      />
    );
  }

  return (
    <div className={classes.pills}>
      {reparti.map((reparto) => (
        <RepartoChip
          key={reparto.id ?? reparto.nome}
          nome={reparto.nome}
          ereditata={proprie.length === 0}
          avviso={
            repartiEsistenti !== null &&
            !isRepartoPresente(reparto.nome, repartiEsistenti)
              ? 'nonPresente'
              : null
          }
        />
      ))}
    </div>
  );
}

const repartoShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  nome: PropTypes.string.isRequired,
});

VisibilitaPills.propTypes = {
  repartiVisibilita: PropTypes.arrayOf(repartoShape),
  ereditata: PropTypes.arrayOf(repartoShape),
  repartiEsistenti: PropTypes.arrayOf(repartoShape),
};

VisibilitaPills.defaultProps = {
  repartiVisibilita: [],
  ereditata: null,
  repartiEsistenti: null,
};
